import registerStore from "./register";

export default {
  modules: {
    registerStore,
  },
};
